// TB-086 (DEF-240): route guard for the per-doctor pages (Calendar View /
// "Schedules", Create slot). An establishment with no doctor selected is sent
// to its doctors list before the page mounts, so no request goes out with
// providerId=null and no raw server error is shown.
import { useToast } from './toast'
import { needsEstDoctorSelection, estDoctorsListLocation, EST_PICK_DOCTOR_MESSAGE } from './estDoctorSelection'

function currentRole () {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null')
    return user ? user.userRole || user.role : ''
  } catch (e) {
    return ''
  }
}

export function requireEstDoctorSelection () {
  if (!needsEstDoctorSelection(currentRole())) return true
  try { useToast().info(EST_PICK_DOCTOR_MESSAGE) } catch (e) { /* toast is best effort */ }
  return estDoctorsListLocation()
}
